import { AvailabilitiesResponse, HourItem } from "./bookingAvailabilities";
import { LOADING_STATE } from "./reduxThunkActions";

enum AVAILABILITIES_CHANGE_TYPE {
  FACTORIES = "FACTORIES",
  NEXT_PERIOD = "NEXT_PERIOD",
  PREVIOUS_PERIOD = "PREVIOUS_PERIOD",
}

interface AvailabilitiesCalendarV3
  extends Omit<
    AvailabilitiesResponse,
    "availabilities" | "hasAvailabilityInScannedPeriod"
  > {
  state: LOADING_STATE;
  availableDays: string[];
  days: { date: string; available: boolean }[];
  hours: Record<string, Required<HourItem>[]>;
  hasAvailabilityInCurrentPeriod: boolean;
  hasAvailabilityInPlaningWindow: boolean;
  isTouched: boolean;
}

interface FetchWeeklyProps {
  serviceLocationId: number;
  changeType: AVAILABILITIES_CHANGE_TYPE;
  wideSearch?: boolean;
}

interface FetchCustomProps {
  serviceLocationId: number;
  numberOfDays: number;
  changeType: AVAILABILITIES_CHANGE_TYPE;
  wideSearch?: boolean;
}

interface ActionParams {
  changeType: AVAILABILITIES_CHANGE_TYPE;
  oldExecutionDateTime: {
    date: string | null;
    time: string | null;
  };
  startDate: string | null;
  isTouched: boolean;
}

export {
  AVAILABILITIES_CHANGE_TYPE,
  AvailabilitiesCalendarV3,
  FetchWeeklyProps,
  FetchCustomProps,
  ActionParams,
};
